import type { SessionLifecycleTiming } from '@core/entities/SessionLifecycle';

export const sessionLifecycleHeaders = {
  expiresAt: 'X-Inav-Session-Expires-At',
  warningAt: 'X-Inav-Session-Warning-At'
} as const;

export function readSessionLifecycleTiming(headers: Headers): SessionLifecycleTiming | undefined {
  const expiresAtUtc = headers.get(sessionLifecycleHeaders.expiresAt);
  const warningAtUtc = headers.get(sessionLifecycleHeaders.warningAt);
  if (!expiresAtUtc || !warningAtUtc) {
    return undefined;
  }

  return {
    expiresAtUtc,
    warningAtUtc
  };
}